/* eslint-disable sonarjs/no-duplicate-string */
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'flightCardContainer',
  'offPeak',
  'aviosOnlyContainer',
  'titleContainer',
  'icon',
  'textContainer',
  'flightInfoContainer',
  'pricesContainer',
  'topCardWrapper',
  'departureTime',
  'arrowLine',
  'arrowPointer',
  'iconWrapper',
  'duration',
  'arrowWrapper',
  'lineWrapper',
  'arrivalTime',
  'departureLocation',
  'stops',
  'flightCardWrapper',
  'flightDetailsButton',
  'flightNumber',
  'flightCarrier',
  'operatedBy',
  'operatedByLogo',
  'bottomCardWrapper',
  'summaryDetails',
  'mainCardInfoContainer',
  'layoverInfo',
  'travelers',
])

export const FlightCard = helpers.defineMultiStyleConfig({
  baseStyle: {
    flightCardWrapper: {
      borderRadius: '2xl',
      overflow: 'hidden',
      borderColor: 'brand.coolgrey2',
      borderStyle: 'solid',
      borderWidth: '1px',
      background: '#FFF',
    },
    flightDetailsButton: {
      height: '2.5rem',
      width: '8.125rem',
      padding: '1rem 1.5rem',
      gap: '1rem',
    },
    flightCardContainer: {
      display: 'flex',
      flexDirection: {
        base: 'column',
        lg: 'row',
      },
      overflow: 'hidden',
      flexWrap: 'wrap',
    },
    offPeak: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 10,
      marginBottom: 0,
      padding:
        'var(--chakra-space-1) var(--chakra-space-1) var(--chakra-space-1) var(--chakra-space-2)',
      width: 'fit-content',
      borderTopLeftRadius: 'base',
      borderTopRightRadius: 'base',
      color: 'brand.white',
      fontSize: 'sm',
      button: {
        marginLeft: 'var(--chakra-space-1)',
        height: 8,
        width: 8,
        span: {
          svg: {
            color: 'brand.white',
          },
        },
      },
    },
    flightInfoContainer: {
      color: 'brand.coolgrey10',
      fontSize: 'sm',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: 3,
      flex: 1,
    },
    pricesContainer: {
      display: 'flex',
      flexDirection: {
        base: 'column',
        md: 'row',
      },
      gap: {
        base: 0,
        md: '.5rem',
      },
      flex: 1,
      padding: 2,
      color: 'brand.coolgrey10',
    },
    topCardWrapper: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      fontSize: 'xl',
    },
    departureTime: {
      gridArea: 'departure-time',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'start',
      color: 'brand.black',
      fontWeight: 'medium',
    },
    arrowLine: {
      width: 'full',
      height: 'full',
      clipPath: 'polygon(0% 48%, 100% 48%, 100% 52%, 0% 52%)',
    },
    arrowPointer: {
      alignSelf: 'center',
      clipPath: 'polygon(0% 0%, 100% 50%, 0% 100%)',
      height: '1ch',
      width: '0.866ch',
    },
    iconWrapper: {
      display: 'flex',
      flexDirection: 'row',
      gap: '0.5rem',
    },
    duration: {
      gap: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      fontSize: 'sm',
    },
    arrowWrapper: {
      margin: 4,
      display: 'flex',
      width: 'full',
      height: 'full',
    },
    lineWrapper: {
      margin: 4,
      height: 'full',
      width: 'full',
    },
    arrivalTime: {
      justifyContent: 'end',
      color: 'brand.black',
      fontWeight: 'medium',
    },
    departureLocation: {
      textAlign: 'left',
    },
    departureTerminal: {
      textAlign: 'left',
    },
    stops: {
      textAlign: 'center',
      display: 'flex',
      gap: '0.3rem',
      fontWeight: 'medium',
    },
    arrivalTerminal: {
      textAlign: 'right',
    },
    flightCarrier: {
      display: 'flex',
      gap: '0.3rem',
      alignItems: 'center',
    },
    flightNumber: {
      gridArea: 'flight-number',
      color: 'brand.black',
      fontWeight: 'medium',
      justifySelf: 'end',
    },
    operatedBy: {
      textAlign: 'right',
      textWrap: 'balance',
    },
    carriers: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      textAlign: 'right',
      justifyContent: 'flex-end',
    },
    bottomCardWrapper: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'space-between',
      marginTop: 2,
    },
    summaryDetails: {
      display: 'grid',
      minHeight: '3.5em',
      gridTemplateColumns: 'min-content 1fr',
      gridTemplateAreas: `
        "travelers carriers"
        "details-button carriers"
      `,
      columnGap: 4,
    },
    layoverInfo: {
      color: 'brand.primaryTeal',
    },
    travelers: {
      display: 'flex',
      whiteSpace: 'nowrap',
      alignItems: 'flex-start',
    },
  },
  variants: {
    aviosOnlyHighlightAllSoldOut: {
      flightInfoContainer: {
        opacity: 0.7,
        pointerEvents: 'none',
      },
    },
    soldOut: {
      flightInfoContainer: {
        opacity: 0.7,
        pointerEvents: 'none',
      },
    },
    aviosOnlyHighlight: {},
  },
})
